import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FacadeService} from "../../shared/service-facade/facade.service";
import {UtilitiesService} from "../../shared/services/utilities.service";
import {Observable} from "rxjs";
import {BASK_URL_CHECK} from "../../shared/constants";
const { version: appVersion } = require('../../../../package.json')

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isBaskBrand$: Observable<boolean>;
  footerText: string = "";
  version : string;
  constructor(private facade: FacadeService,
              private changeDetector: ChangeDetectorRef,
              private utils: UtilitiesService) {
    this.version = appVersion;
    this.isBaskBrand$ = this.facade.isBaskBrand$
  }

  ngOnInit(): void {
    this._loadFooterProperties();

    this.facade.brandProductSettingsLoaded$.subscribe(value => {
      if (!value) { return; }

      this._loadFooterProperties();
      this.changeDetector.detectChanges();
    });

  }

  private _loadFooterProperties(): void {
    let footerText = this.facade.getStorageItem("footerText");

    if (!footerText) {
      if(location.href.includes(BASK_URL_CHECK))
        footerText = this.facade.getStorageItem("bask-default-footer");
      else
        footerText = this.facade.getStorageItem("verify-code-footer");
    }

    if (footerText !== null)
      this.footerText = this.utils.replaceStringContent(footerText, new Map<string, string>([["{{year}}", new Date().getFullYear().toString()]]))
  }

}
